<script setup>
import { inject, watch, ref } from 'vue'
import { UAParser } from 'ua-parser-js'
import { useAppStore } from '@/stores/app.js'
import { storeToRefs } from 'pinia'
import InlineSvg from 'vue-inline-svg'
import translatorLanguages from '@/data/translator-languages.json'
import app from '@/main.js'

const close = inject('close')
const { device } = UAParser()

const appStore = useAppStore()

const {
  chatTranslationLangSelected,
  chatTranslationLang
} = storeToRefs(appStore)

const language = ref(chatTranslationLang.value)

function closeWithDelay () {
  setTimeout(() => {
    close()
  }, 500)
}

watch(language, (value) => {
  chatTranslationLangSelected.value = value
  closeWithDelay()
})
</script>

<template>
  <div
    :class="[device.is('mobile') ? 'rounded-t-xl self-end' : 'rounded-xl self-center']"
    class="bg-white p-4 shadow-lg w-full relative max-h-[96%] overflow-y-auto thin-scrollbar"
    @click.stop>
    <div class="flex items-center justify-between mb-6">
      <div/>

      <h2 class="text-base">
        {{ app.$i18n.t('translate.select_preferred_language') }}
      </h2>

      <button type="button" @click="close">
        <InlineSvg
          class="h-4 w-4"
          :src="require('@/assets/fontawesome/regular/xmark.svg')"/>
      </button>
    </div>

    <p>
      {{ app.$i18n.t('translate.select_preferred_language_text') }}
    </p>

    <fieldset>
      <div class="mt-4 border-t border-b border-gray-100 divide-y divide-gray-100">
        <div
          v-for="item in translatorLanguages"
          :key="item.code"
          class="relative flex items-start">
          <div class="min-w-0 flex-1 text-sm">
            <label
              :for="item.code"
              class="flex text-gray-700 select-none py-4">
              <span class="text-[20px]">
                {{ item.flag }}
              </span>

              <span
                :class="{ 'font-bold': language === item.code }"
                class="pl-2 text-base flex">
                {{ item.name }}
              </span>
            </label>
          </div>

          <div class="ml-3 flex items-center h-5 my-4">
            <input
              :id="item.code"
              v-model="language"
              :value="item.code"
              :name="item.name"
              type="radio"
              class="focus:ring-primary h-4 w-4 text-primary border-gray-300">
          </div>
        </div>
      </div>
    </fieldset>
  </div>
</template>
